import React from 'react'
import MuiTextField from '@mui/material/TextField'
import BaseDisplayItem, {
    BaseDisplayItemProps,
    BaseDisplayItemState,
    DisplayMode,
} from '@/feature/DisplayItems/BaseDisplayItem'

/* ---------- Types (align with BaseDisplayItem) ---------- */

interface Item {
    id: string | number
    // add optional settings if your BaseDisplayItem.getSetting expects it
    settings?: Record<string, unknown>
    def_dossier_def_field?: {
        def_field?: {
            settings?: Record<string, unknown>
        }
    }
}

interface Kedo {
    t: (key: string) => string
}

interface Props extends BaseDisplayItemProps<string> {
    item: Item
    kedo: Kedo
    mode: DisplayMode
    errors?: string | string[]
    onKeyPress?: (id: Item['id'], event: React.KeyboardEvent) => void
}

class EmailField extends BaseDisplayItem<string> {
    // If your BaseDisplayItem.innerRef is HTMLElement-typed, this cast is the least-bad option.
    // If you adopt the generic-ref BaseDisplayItem version, this cast goes away.
    private inputRef = this
        .innerRef as unknown as React.RefObject<HTMLInputElement>

    private getErrorText(): string {
        const errs = (this.props as Props).errors
        if (!errs) return ''
        return Array.isArray(errs) ? errs.join(', ') : errs
    }

    renderShow(): React.ReactNode {
        const props = this.props as Props

        if (!props.value) {
            return (
                <span className="text-muted small">
                    {props.kedo.t('Unknown')}
                </span>
            )
        }

        return <a href={`mailto:${props.value}`}>{props.value}</a>
    }

    renderEdit(): React.ReactNode {
        const props = this.props as Props

        return (
            <MuiTextField
                size="small"
                fullWidth
                name="emailaddress"
                type="email"
                inputRef={this.inputRef}
                value={this.state.value ?? ''}
                onChange={(e) => this.updateValue(e.target.value)}
                error={this.isInvalid()}
                helperText={this.isInvalid() ? this.getErrorText() : ''}
            />
        )
    }

    renderSearch(): React.ReactNode {
        const props = this.props as Props

        return (
            <MuiTextField
                size="small"
                fullWidth
                type="text"
                value={props.value ?? ''}
                onChange={(e) =>
                    props.changeValue?.(props.item.id, e.target.value)
                }
                onKeyPress={
                    props.onKeyPress
                        ? (e) => props.onKeyPress!(props.item.id, e)
                        : undefined
                }
            />
        )
    }
}

export default EmailField
